/**
 * Upload each captured image at most once per generated file. A slot that the
 * file record already lists in `Snapshots` is skipped; a failed capture can be
 * retried by the next render.
 *
 * @param {object} options
 * @param {string} [options.fileId]
 * @param {string} [options.conversationId]
 * @param {Record<string, string>} [options.existing] the file's Snapshots map
 * @param {(image: { slot: number, data: string }) => Promise<unknown>} options.upload
 */
export function createSnapshotQueue({ fileId, conversationId, existing = {}, upload }) {
  const done = new Set(Object.keys(existing || {}));
  let chain = Promise.resolve();
  return {
    ready(position, capture) {
      const key = `s${position}`;
      if (!fileId || !conversationId || typeof upload !== "function" || done.has(key)) return chain;
      done.add(key);
      chain = chain.then(async () => {
        try {
          const data = await capture();
          if (typeof data === "string" && data.startsWith("data:image/png")) await upload({ slot: position, data });
        } catch (error) {
          done.delete(key);
          console.warn("[HelpChat] Could not save the chart snapshot", error);
        }
      });
      return chain;
    },
  };
}
